import * as React from "react";
import { cn } from "../../../helpers";
import styles from "./PageHeader.module.scss";

export interface PageHeaderProps {
    title: React.ReactNode;
    // Short supporting text shown next to the title, e.g. a record count
    meta?: React.ReactNode;
    actions?: React.ReactNode;
    className?: string;
}

// One compact row: title (and optional meta) on the left, actions on the right.
export function PageHeader({ title, meta, actions, className }: PageHeaderProps) {
    return (
        <div className={cn(styles.pageHeader, className)}>
            <div className={styles.titleGroup}>
                <h1 className={styles.title}>{title}</h1>
                {meta && <span className={styles.meta}>{meta}</span>}
            </div>
            {actions && <div className={styles.actions}>{actions}</div>}
        </div>
    );
}
